import type {
  BlueprintWithOrganizationData,
  ConciergeTier,
} from '@rtkwlf/track-public';

/**
 * Gets all blueprints excluded from orgTier
 *
 * @param blueprints
 * @param orgTier
 * @returns BlueprintWithOrganizationData[], filtered blueprints
 */
export const getExcludedBlueprints = (
  blueprints: BlueprintWithOrganizationData[],
  orgTier: ConciergeTier | undefined,
) => {
  return blueprints.filter((bp) => Number(bp.tier) > Number(orgTier));
};
